import { FC } from "react";
import TabComponent from "../../components/molecule/Tab/TabComponent";
import IndicatorAnalysis from "./Indicator/IndicatorAnalysis";
import RegionAnalysis from "./Region/RegionAnalysis";
import { INDICATOR_SUMMARY } from "../../utils/constants";
import { Heading, Text } from "@chakra-ui/react";

const Indicator: FC = () => {
  return (
    <TabComponent
      tabs={["Análise por regiões", "Análise por indicadores"]}
      panels={[<RegionAnalysis />, <IndicatorAnalysis />]}
      headingElement={
        <>
          <Heading as="h1">Indicadores</Heading>
          <Text>{INDICATOR_SUMMARY}</Text>
        </>
      }
    />
  );
};

export default Indicator;
